import { LegacyPendingUserList } from '~/features/LegacyPendingUserList';

export const Screen: React.FC = () => <LegacyPendingUserList />;
